import React from 'react';

const CheckoutAgreementsFormikContext = React.createContext();

export default CheckoutAgreementsFormikContext;
